export default {
  law: {
    title: '特定商取引法に基づく表記',
    serviceName: 'サービス名',
    companyName: '販売事業者',
    representative: '代表者名',
    address: '所在地',
    contact: 'お問い合わせ先',
    paymentTerms: '代金の支払方法・支払時期',
    deliverySchedule: '商品の引渡時期',
    sellingPrice: '商品等の販売価格',
    shippingFee: '送料',
    additionalFee: '販売価格・送料等以外に必要な料金',
    salesRestrictions: '販売期間・販売数量の制限',
    returnsAndCancellations: '返品・キャンセル',
    otherConditions: 'その他の条件'
  }
};
